import { api } from "../services/api.js";

document.addEventListener("DOMContentLoaded", () => {
    const btnSubmit = document.getElementById("btnSubmitJob");
    const form = document.getElementById("applyJobForm");

    // Fetch Experience Options dynamically
    const expSelect = document.getElementById("appExperience");
    if (expSelect) {
        api.get("jobs/experience").then(response => {
            if (response && !response.error && response.data && Array.isArray(response.data.items)) {
                response.data.items.forEach(exp => {
                    const opt = document.createElement("option");
                    opt.value = exp;
                    opt.textContent = exp;
                    expSelect.appendChild(opt);
                });
            }
        }).catch(err => console.error("Error fetching experience options:", err));
    }

    if (!btnSubmit || !form) return;

    btnSubmit.addEventListener("click", async () => {
        // HTML5 Validation
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        // Optional Captcha Validation
        let captchaToken = "";
        try {
            if ($("#targetElement").length > 0) {
                if (typeof grecaptcha !== 'undefined') {
                    captchaToken = grecaptcha.getResponse();
                }
                
                if (!captchaToken) {
                    Swal.fire("Oops!", "Please complete the Captcha verification.", "warning");
                    return;
                }
            }
        } catch (e) {
            console.warn("Captcha verification ignored or not initialized properly.", e);
        }

        // Get File
        const resumeInput = document.getElementById("appResume");
        const file = resumeInput.files[0];
        if (!file) {
            Swal.fire("Oops!", "Please select a resume file to upload.", "warning");
            return;
        }

        // Get Form Values
        const applicantName = document.getElementById("appFullName").value.trim();
        const email = document.getElementById("appEmail").value.trim();
        const phone = document.getElementById("appPhone").value.trim();
        const state = document.getElementById("appState").value.trim();
        const location = document.getElementById("appLocation").value.trim();
        const experience = document.getElementById("appExperience").value;
        const linkedinLink = document.getElementById("appLinkedin").value.trim();
        const websiteLink = document.getElementById("appWebsite").value.trim();
        const jobId = document.getElementById("appJobId").value;

        // Custom Validations
        const nameRegex = /^[A-Za-z\s.]{2,50}$/;
        if (!nameRegex.test(applicantName)) {
            Swal.fire("Oops!", "Please enter a valid full name (letters only).", "warning");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            Swal.fire("Oops!", "Please enter a valid email address.", "warning");
            return;
        }

        // Phone: remove spaces/dashes and check if it's 10 digits
        const cleanPhone = phone.replace(/[- ]/g, "");
        const phoneRegex = /^[0-9]{10,15}$/;
        if (!phoneRegex.test(cleanPhone)) {
            Swal.fire("Oops!", "Please enter a valid phone number (10-15 digits).", "warning");
            return;
        }

        try {
            // Update UI
            btnSubmit.disabled = true;
            const originalText = btnSubmit.textContent;
            btnSubmit.innerHTML = `<i class="fa-solid fa-spinner fa-spin"></i> Uploading...`;

            // 1. Upload Resume File
            const formData = new FormData();
            formData.append("file", file);
            formData.append("file_type", "applicant_resumes");

            // We use axios directly for multipart/form-data
            const uploadRes = await api.post("content/upload/public-with-no-token", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            // Assuming upload API returns the file URL or ID inside response.data
            // The exact key depends on backend, but let's assume uploadRes.data or uploadRes.fileId
            let uploadedFileRef = "";
            if (uploadRes && uploadRes.data && uploadRes.data.attachment_id) {
                uploadedFileRef = uploadRes.data.attachment_id;
            } else if (uploadRes && uploadRes.data && uploadRes.data.url) {
                uploadedFileRef = uploadRes.data.url;
            } else {
                uploadedFileRef = uploadRes?.data || "";
            }

            // 2. Submit Application Payload
            btnSubmit.innerHTML = `<i class="fa-solid fa-spinner fa-spin"></i> Submitting...`;

            const payload = {
                applicantName,
                email,
                phone,
                state,
                location,
                experience,
                linkedinLink,
                websiteLink,
                jobId,
                resumeFile: uploadedFileRef
            };

            const submitRes = await api.post("applicants/applicant/add", payload);

            if (submitRes && (submitRes.status === 200 || submitRes.success || !submitRes.error)) {
                // Close Apply Modal
                const applyModalEl = document.getElementById("applyJobModal");
                const applyModalInstance = bootstrap.Modal.getInstance(applyModalEl);
                if (applyModalInstance) {
                    applyModalInstance.hide();
                }
                
                // Reset Form
                form.reset();
                if ($("#targetElement").length > 0) {
                    try { $("#targetElement").EasyCaptcha('reset'); } catch (e) {}
                }

                // Show Success Modal
                const successModalEl = document.getElementById("successModal");
                if (successModalEl) {
                    const successModalInstance = bootstrap.Modal.getOrCreateInstance(successModalEl);
                    successModalInstance.show();
                }
            } else {
                throw new Error("Failed to submit application");
            }

        } catch (error) {
            console.error("Job Apply Error:", error);
            // Error alert is likely handled by api interceptor, but fallback:
            if (!error.response) {
                Swal.fire("Error", "Something went wrong while applying. Please try again.", "error");
            }
        } finally {
            // Restore button
            btnSubmit.disabled = false;
            btnSubmit.textContent = "Apply Now";
        }
    });
});
